<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="mt-3" >
            <ul class="horizontal-menu " > 
                <li>  <router-link :to="{name: 'Integration', params: { APP: 'OPENCART' } }" class="not-active pl-0" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
            </ul>
        </div>
        
        <div class="row mt-3" >
            
            <b-form  @submit.prevent="submit" class="atlass-form col-12 mt-3 " >
                
                <div class="col-12 border-bottom-gray pb-2 mb-3" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Integration details </h2> </span>
                    <span class="d-inline-block float-right" > 
                        
                        <span v-if="data.last_update" class="font-300 font-size-14 line-height-31 mr-2" > Last updated at: <b > {{formatData(data.last_update)}} </b> </span>
                        
                        <b-dropdown v-if="!editable"  size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14">
                            <b-dropdown-item-button @click="edit"  >Edit</b-dropdown-item-button>
                            <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                            <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
                        </b-dropdown>
                        
                        <span v-else-if="editable" >
                            <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                            <b-button @click="edit" v-if="type == 'edit'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                        </span>
                    </span>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> Integration Name: </label>
                        <span v-if="!editable" class="font-weight-bold" > {{data.Name}} </span>
                        <b-form-input v-else-if="editable" id="NameInput"
                        type="text"
                        v-model="data.Name"
                        required
                        placeholder="Name">
                        </b-form-input>
                    </b-form-group>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> Integration Tag: </label>
                        <span v-if="!editable" class="font-weight-bold" > !{{data.Tag}} </span>
                        <b-input-group v-else-if="editable" >
                            <b-input-group-prepend is-text>  !</b-input-group-prepend>
                            <b-form-input  id="apiKeyInput"
                            type="text"
                            v-model="data.Tag"
                            required
                            placeholder="woocommerce">
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> OpenCart store URL: </label>
                        <span v-if="!editable" class="font-weight-bold" > {{data.opencart_url}} </span>
                        <b-form-input v-else-if="editable"
                        type="text"
                        v-model="data.opencart_url"
                        required
                        placeholder="Store URL ( example: https://yourdomain.com )">
                        </b-form-input>
                    </b-form-group>
                </div>
                
                 <div class="col-12 form-group" >
                     <b-form-group >
                        <label> OpenCart store Timezone: </label>
                        <span v-if="!editable" class="font-weight-bold" > {{data.store_timezone}} </span>
                        <select v-model="data.store_timezone" class="form-control" v-else-if="editable" >
                            <option v-for="timezone in timezones" v-bind:value="timezone">
                                {{ timezone }}
                              </option>
                        </select>
                    </b-form-group>
                </div>
                
                <div class="col-12 form-group" v-if="data.appkey" >
                     <b-form-group >
                        <label> OpenCart App Key: </label>
                        
                        <span v-if="!editable" id="script-appkey" class="font-weight-bold" > {{data.appkey}} </span>
                        <a v-if="!editable" class="btn btn-copy" @click="copyScript( 'appkey' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </a>
                         
                        <b-form-input v-else-if="editable" id="ServerInput"
                        type="text"
                        v-model="data.appkey"
                        disabled
                        placeholder="">
                        </b-form-input>
                         
                    </b-form-group>
                </div>
                
                <div class="col-12 form-group" v-if="data.opencart_hash" >
                     <b-form-group >
                        <label> OpenCart Hash: </label>
                        
                        <span v-if="!editable" id="script-hash" class="font-weight-bold" > {{data.opencart_hash}} </span>
                        <a v-if="!editable" class="btn btn-copy" @click="copyScript( 'hash' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </a>
                         
                        <b-form-input v-else-if="editable" id="ServerInput"
                        type="text"
                        v-model="data.opencart_hash"
                        disabled
                        placeholder="">
                        </b-form-input>
                         
                    </b-form-group>
                </div>
                
                <div class="col-12 form-group" v-if="ID != 'new'" >
                     <b-form-group >
                        <label> Status: </label>
                        <span v-if="!editable" >
                            <b v-if="data.Status == 1" > Active </b>
                            <b v-else-if="data.Status == 0"  > Inactive </b>
                        </span>
                         
                        <div v-else-if="editable" >
                            <b-form-checkbox v-model="data.Status" name="check-button" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                            <span v-if="data.Status" > Active </span>
                            <span v-else-if="!data.Status" > Inactive </span>
                        </div>
                         
                    </b-form-group>
                </div>

            </b-form>
            
        </div>
        
        <div v-if="integrating"  class="col-12 mt-4" >
            <p class="text-center font-weight-bold" > Setting everything up. Might take a while... </p>
            <spinner type="small" ></spinner>
        </div>
        
        
        <div class="row mt-5 mb-4 font-size-14" v-if="type == 'edit' && data.Status == 1 && !integrating" >
    
            <div class="col-12" >
                
                <div class="col-12 border-bottom-gray pb-2 mb-4" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Settings </h2> </span>
                </div>

                <div class="col-12 mt-4 d-none" >
                    <div class="row" >
                        <div class="col-12 col-md-10" >
                            <h2 class="h3 font-weight-bold line-height-31" > Test Integration  <font-awesome-icon :icon="['fas', 'check-circle']" v-if="data.verified" class="font-size-16 color-green" /> </h2>
                            <p class="mt-1" >
                                This action will perform a test to see if the integration is fully set up and running as intended
                            </p>
                        </div>
                        <div class="col-12 col-md-2 text-right" >
                            <b-button v-if="type == 'edit'" @click="testIntegration" variant="outline-secondary" class="btn btn-sm" > 
                                <span v-if="!checkingIntegration" > Run test </span> 
                                <span v-else-if="checkingIntegration" > Checking  <font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin" /> </span> 
                            </b-button>
                        </div>
                    </div>
                </div>


                <div class="col-12 mt-4" >
                    <div class="row" >
                        <div class="col-12" >
                            <h2 class="h3 font-weight-bold line-height-31" > Neglected emails  </h2>
                            
                            <b-alert show variant="secondary" class="w-100 mb-2 mt-2" >
                                <strong> List of emails to neglect: </strong>
                                <br>
                                If an order is sent from one of these emails, it will be neglected and will be attributed to an email based on firstname_lastname@yourstore.com.
                                <br><br>
                                This option is dedicated when using OpenCart's guest checkout without an email address.

                                <div class="mt-3 mb-3" style="min-height: 33px;" > 
                                    <span v-if="!data.neglectedEmails || data.neglectedEmails.length == 0" class="alert alert-primary d-block p-0 pl-5 pr-5 text-center mr-5 ml-5" style="margin-top: 5px; margin-bottom: 5px;" > No emails added yet. Add them below. </span>

                                    <span v-else-if="data.neglectedEmails && data.neglectedEmails.length >= 0" v-for="(email, index) in data.neglectedEmails" class="d-inline-block box-span box-span-removeable bg-color-white" style="background: #fff!important;"   > {{email}} <font-awesome-icon icon="times" @click="removeFromArray( 'neglectedEmails', email)" /> </span>
                                </div>

                                <label for="word" > ADD EMAIL: </label>
                                <b-form-input id="word" @change="addWord( 'neglectedEmails' )"
                                    type="email"
                                    v-model="newNeglectEmail"
                                    style="background: #fff!important;"  
                                    placeholder="ex: orders@yourdomain.com">
                                </b-form-input>

                            </b-alert> 
                            
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-4 mb-4" >
                    <div class="row" >
                        <div class="col-12 " >
                            
                            <h2 class="h3 font-weight-bold line-height-31" > Order statuses  </h2>
                            
                            <b-alert show variant="secondary" class="w-100 mb-2 mt-2" >
                                <strong> List of order status from OpenCart that will be marked as <b-badge variant="secondary"> processing </b-badge>: </strong>

                                <div class="mt-3 mb-3" style="min-height: 33px;" > 
                                    <span v-if="data.status_processing.length == 0" class="alert alert-primary d-block p-0 pl-5 pr-5 text-center mr-5 ml-5" style="margin-top: 5px; margin-bottom: 5px;" > No words added yet. Add them below. </span>

                                    <span v-for="(word, index) in data.status_processing" class="d-inline-block box-span box-span-removeable bg-color-white" style="background: #fff!important;"   > {{word}} <font-awesome-icon icon="times" @click="removeFromArray( 'processing', word)" /> </span>
                                </div>

                                <label for="word" > ADD STATUS: </label>
                                <b-form-input id="word" @change="addWord( 'processing' )"
                                    type="text"
                                    v-model="newProcessingStatus"
                                    style="background: #fff!important;"  
                                    placeholder="ex: chargeback">
                                </b-form-input>

                            </b-alert>  
                            
                            <b-alert show variant="secondary" class="w-100 mb-2 mt-2" >
                                <strong> List of order status from OpenCart that will be marked as <b-badge variant="success"> completed </b-badge>: </strong>

                                <div class="mt-3 mb-3" style="min-height: 33px;" > 
                                    <span v-if="data.status_completed.length == 0" class="alert alert-primary d-block p-0 pl-5 pr-5 text-center mr-5 ml-5" style="margin-top: 5px; margin-bottom: 5px;" > No words added yet. Add them below. </span>
                                    
                                    <span v-for="(word, index) in data.status_completed" class="d-inline-block box-span box-span-removeable bg-color-white" style="background: #fff!important;"   > {{word}} <font-awesome-icon icon="times" @click="removeFromArray( 'completed', word)" /> </span>
                                </div>

                                <label for="word" > ADD STATUS: </label>
                                <b-form-input id="word" @change="addWord( 'completed' )"
                                    type="text"
                                    v-model="newCompletedStatus"
                                    style="background: #fff!important;"  
                                    placeholder="ex: successful">
                                </b-form-input>

                            </b-alert>  
                            
                            <b-alert show variant="secondary" class="w-100 mb-2 mt-2" >
                                <strong> List of order status from OpenCart that will be marked as <b-badge variant="danger"> refunded </b-badge>: </strong>

                                <div class="mt-3 mb-3" style="min-height: 33px;" > 
                                    <span v-if="data.status_refunded.length == 0" class="alert alert-primary d-block p-0 pl-5 pr-5 text-center mr-5 ml-5" style="margin-top: 5px; margin-bottom: 5px;" > No words added yet. Add them below. </span>
                                    
                                    <span v-for="(word, index) in data.status_refunded" class="d-inline-block box-span box-span-removeable bg-color-white" style="background: #fff!important;"   > {{word}} <font-awesome-icon icon="times" @click="removeFromArray( 'refunded', word)" /> </span>
                                </div>

                                <label for="word" > ADD STATUS: </label>
                                <b-form-input id="word" @change="addWord( 'refunded' )"
                                    type="text"
                                    v-model="newRefundedStatus"
                                    style="background: #fff!important;"  
                                    placeholder="ex: refunded">
                                </b-form-input>

                            </b-alert>  
                            
                        </div>
                        
                    </div>
                </div>
    
            </div>
            
        </div>
        
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';
import m from 'moment-timezone';
    
export default {
    name: 'OPENCART',
    components:{
        
    },
    props: {
        ID:{
            type: [String]
        }
    },
    data: function(){
        return {
            loaded: false, 
            data:{
                Name: "OpenCart Integration",
                Tag: "opencart",
                opencart_url: "",
                store_timezone: "UTC",
                opencart_hash: "",
                Status: true,
                neglectedEmails: [],
                status_processing: ["Pending", "Processing", "Processed"],
                status_completed: ["Shipped", "Complete"],
                status_refunded: ["Canceled", "Denied", "Canceled Reversal", "Failed", "Refunded", "Reversed", "Chargeback", "Expired", "Voided"],
            },
            timezones:[],
            type: 'edit',
            editable: false,
            checkingIntegration: false,
            creatingWebhooks: false,
            integrating: false,
            newProcessingStatus: "",
            newCompletedStatus: "",
            newRefundedStatus: "",
            newNeglectEmail: "",
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
        //console.log(  )
        
    },
    mounted: function () {    
        
        this.timezones = []
        this.timezones = m.tz.names()
        
        if( this.ID == 'new' ){
            this.loaded = true
            this.editable = true
            this.type = 'add'
        }else{
            this.get_data( this.ID );
        }
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data( ID ){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations').doc( ID )
                                    
            return ref.get()
                .then((snapshot) => {
                    if( !snapshot.empty ){
                        console.log(snapshot.data())
                        this.data = snapshot.data()
                        this.data.docID = snapshot.id
                        
                        //this.data.status_processing = ["Pending", "Processing", "Processed"]
                        //this.data.status_completed = ["Shipped", "Complete"]
                        //this.data.status_refunded = ["Canceled", "Denied", "Canceled Reversal", "Failed", "Refunded", "Reversed", "Chargeback", "Expired", "Voided"]
                                                
                        this.data.appkey = orgID
                        
                        this.type = 'edit'
                    }else{
                        console.log("No integration set")
                    }
                    
                    this.loaded = true;
                })
          
        },
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        edit(){
            this.editable = !this.editable
        },
        validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
            return !!pattern.test(str);
        },
        submit(){
                        
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            let errors = false
            if( !this.validURL( this.data.opencart_url ) ){
                errors = true
            }
            
            
            
            //console.log(document)
            if( errors ){
                
                this.$toast.error({
                    title: 'Error',
                    message: "Please make sure you enter a valid URL."
                })
                
            }else{
                
                let document = {
                    "APPKEY": orgID,
                    "APP": "OPENCART",
                    "Name" : this.data.Name,
                    "Type" : 'eccommerce',
                    "Tag" : this.data.Tag,
                    "opencart_hash": this.data.opencart_hash,
                    "opencart_url": this.data.opencart_url,
                    "store_timezone": this.data.store_timezone,
                    "Status": this.data.Status,
                }
                
                if( this.type == 'add' ){

                    this.integrating = true

                    document.status_processing = ["Pending", "Processing", "Processed"],
                    document.status_completed = ["Shipped", "Complete"],
                    document.status_refunded = ["Canceled", "Denied", "Canceled Reversal", "Failed", "Refunded", "Reversed", "Chargeback", "Expired", "Voided"],
                    document.datetime = Math.round(+new Date()/1000)

                    let ref = db.collection('organizations/'+orgID+'/integrations')

                    return ref.add( document )
                     .then((result)=>{
                        let docID = result.id

                        console.log(docID)

                        let opencart_hash = btoa( orgID+"_"+docID )
                        db.collection('organizations/'+orgID+'/integrations').doc( docID ).update( { opencart_hash: opencart_hash } )
                        this.data.opencart_hash = opencart_hash

                        this.$toast.success({
                            title:'Success',
                            message: 'Integration successful'
                        })

                        this.$router.push({
                            name: "OPENCART",
                            params: { ID: docID }
                        }); 

                        this.type = 'edit'
                        this.editable = false
                        this.integrating = false
                    })

                }else{

                    document.last_update = Math.round(+new Date()/1000)

                    let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                    return ref.set( document, { merge: true } )
                    .then((result)=>{

                        this.$toast.success({
                            title:'Success',
                            message: 'Changed saved '
                        })

                        this.loaded = true

                    })

                }
            }
                

            
        },
        
        testIntegration(){
            
            this.checkingIntegration = true
            
            let params = Cookies.get('user-token')
            //let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": this.data.docID }
            //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/woocommerce/test', headers: headers, data: data })
                .then(resp => {
                
                
                if( resp.status == 200 ){
                    let updateData = { verified: true, webhooks: false }
                    
                    let r = resp.data;
                    if( r == 'success' ){
                        this.$toast.success({
                            title:'Success',
                            message: 'Integration successful'
                        })
                        
                        //updateData = { verified: true, webhooks: true }
                        updateData.webhooks = true
                        
                        this.data.verified = true;
                        this.data.webhooks = true;
                        
                    }else{
                        this.$toast.error({
                            title:'Error',
                            message: 'Integration is not fully set. Please reach out to us'
                        })
                        
                    }
                    
                    //ADD VERIFIED BADGE
                    let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                    const db = this.$firebase.firestore();
                    let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )

                    return ref.update( updateData )
                    .then((result)=>{
                        this.checkingIntegration = false
                    })
                                                
                }else{
                    this.data.verified = false;
                    this.data.webhooks = false;
                    this.checkingIntegration = false
                    
                    this.$toast.error({
                        title:'Error',
                        message: 'Integration is not fully set. Could not create webhooks due to lacking permissions. Please proceed by manually creating them.'
                    })
                }
                    
                
            }).catch(error => {
                console.log(error)
                this.data.verified = false;
                this.data.webhooks = false;
                this.checkingIntegration = false

                this.$toast.error({
                    title:'Error',
                    message: 'Integration is not fully set. Could not create webhooks due to lacking permissions. Please proceed by manually creating them.'
                })
            }); //end axios 
            
        },        
        
        addWord: function(target){
            
            if( target == 'processing' ){
                this.data.status_processing.push( this.newProcessingStatus )
            }else if( target == 'completed' ){
                this.data.status_completed.push( this.newCompletedStatus )
            }else if( target == 'refunded' ){
                this.data.status_refunded.push( this.newRefundedStatus )
            }else if( target == 'neglectedEmails' ){
                if( this.newNeglectEmail ){
                    if( !this.data.neglectedEmails || this.data.neglectedEmails == undefined ){
                        this.data.neglectedEmails = []
                    }
                    this.data.neglectedEmails.push( this.newNeglectEmail )
                }
            }
            
            this.newProcessingStatus = ""
            this.newCompletedStatus = ""
            this.newRefundedStatus = ""
            this.newNeglectEmail = ""
            
            //UPDATE
            document.last_update = Math.round(+new Date()/1000)
            let ref = this.$firebase.firestore().collection('organizations/'+helper.getLoggedInOrganization( this.$store.getters.isAdmin )+'/integrations').doc( this.data.docID )
            return ref.set( this.data, { merge: true } )
            .then((result)=>{

                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })

                this.loaded = true

            })
            
        },
        
        removeFromArray: function(target,word){
            
            //console.log( "removing "+ word +" from "+ target )
                        
            if( target == 'processing' ){
                this.data.status_processing = this.data.status_processing.filter(item => item !== word)
            }else if( target == 'completed' ){                
                this.data.status_completed = this.data.status_completed.filter(item => item !== word)
            }else if( target == 'refunded' ){
                this.data.status_refunded = this.data.status_refunded.filter(item => item !== word)
            }else if( target == 'neglectedEmails' ){
                this.data.neglectedEmails = this.data.neglectedEmails.filter(item => item !== word)
            } 
                            
            //UPDATE
            document.last_update = Math.round(+new Date()/1000)
            let ref = this.$firebase.firestore().collection('organizations/'+helper.getLoggedInOrganization( this.$store.getters.isAdmin )+'/integrations').doc( this.data.docID )
            return ref.set( this.data, { merge: true } )
            .then((result)=>{

                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })

                this.loaded = true

            })
            
        },
        
        toggleSwitch( field, value ){
            
            let document = {}
            let update = true;
            
            console.log(this.data)
            
            if( field == 'Status' ){
                this.data.Status = value
                document.Status = value
            }else if( field == 'sync_leads' ){
                let settings = {}
                settings.sync_leads = this.data.settings.sync_leads
                document['settings.sync_leads'] = !this.data.settings.sync_leads
                
                if( !this.data.settings.sync_leads ){
                    update = false
                }else{
                    update = true
                }
                
            }else if( field == 'attribute_campaigns' ){
                document['settings.attribute_campaigns'] = !this.data.settings.attribute_campaigns
            }else if( field == 'audience_ID' ){
                if( this.data.audience_ID == '' ){
                    this.data.settings.sync_leads = false
                }
                document['settings.sync_leads'] = this.data.settings.sync_leads
                document.audience_ID = this.data.audience_ID
            }
            
            document.last_update = Math.round(+new Date()/1000)
            
            if( update ){
                //UPDATE FIRESTORE
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                return ref.update( document )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                })
            }
            
        },//end toggleSwitch

        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },        
        delete: function( ){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )
            return ref.delete()
            .then(function(){

                 this.$toast.success({
                    title: 'Success',
                    message: 'Integration deleted'
                })

                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Integration',
                        params: { APP: "OPENCART" }
                    }); 
                }.bind(this), this.timeout );

            }.bind(this))
            .catch(function(error){

                //console.error("Error updating document: ", error);
                this.$toast.error({
                    title: 'Error',
                    message: "Something went wrong: "+error
                })

                this.loaded = true

            }.bind(this))
            
        },
        
        copyScript( type ){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script-"+type));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        }
        
    },
    watch: {
        ID: function(){
            this.docID = this.ID
            //this.get_data();
            
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/integrations/OPENCART.vue